import { create } from 'zustand'
import { createCompanySlice, initialCompany } from '../slices/companySlice'
import { CompanyStore } from '../types'
import { Permission } from '../../types/ffe'

export const useCompanyStore = create<CompanyStore>((set, get, store) => ({
  company: initialCompany,
  teamMembers: [],
  user: null,
  ...createCompanySlice(set, get, store)
}))

export const usePermissions = () => {
  const permissions = useCompanyStore((state) => state.user?.permissions)

  const permissionArray = Object.entries(permissions ?? {})
    .filter(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ([_key, value]) => value === true
    )
    .map(([key]) => key as Permission)

  const hasPermissions = (checkingPermissions: Array<Permission>) => {
    if (!permissions) return false

    // check if all permissions are present
    return checkingPermissions.every((permission) =>
      permissionArray?.includes(permission)
    )
  }

  return { hasPermissions, permissions }
}
